import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, AwardIcon } from 'lucide-react';
export function DifferentiationSection() {
  return <section id="patented" className="py-10 md:py-20 bg-brand-darkest relative overflow-hidden" data-id="element-161">
      {/* Ambient background glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-cyan/[0.03] rounded-full blur-[60px] pointer-events-none" data-id="element-162" />
      <div className="absolute top-0 left-1/4 w-[300px] h-[300px] bg-brand-electric/[0.04] rounded-full blur-[50px] pointer-events-none" data-id="element-163" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        {/* Patent Section */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative p-6 md:p-14 text-center rounded-2xl overflow-hidden" style={{
        background: 'linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(0,102,255,0.03) 50%, rgba(10,14,26,0.8) 100%)',
        border: '1px solid rgba(0,102,255,0.2)',
        boxShadow: '0 0 60px rgba(0,102,255,0.08), 0 0 120px rgba(0,102,255,0.04), inset 0 1px 0 rgba(255,255,255,0.06)'
      }} data-id="element-165">
          {/* Top edge highlight */}
          <div className="absolute top-0 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-brand-cyan/40 to-transparent" data-id="element-166" />

          {/* Background radial glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[200px] bg-brand-cyan/[0.06] rounded-full blur-[80px] pointer-events-none" data-id="element-167" />

          <div className="relative z-10" data-id="element-168">
            {/* Shield Icon with glow */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative w-16 h-16 md:w-24 md:h-24 mx-auto mb-6 md:mb-8" data-id="element-169">
              {/* Glow ring behind icon */}
              <div className="absolute inset-0 rounded-full bg-brand-cyan/10 blur-xl" data-id="element-170" />
              <div className="relative w-full h-full rounded-full flex items-center justify-center" style={{
              background: 'radial-gradient(circle, rgba(0,102,255,0.15) 0%, rgba(0,102,255,0.05) 70%, transparent 100%)',
              border: '1.5px solid rgba(0,102,255,0.35)',
              boxShadow: '0 0 30px rgba(0,102,255,0.15), inset 0 0 20px rgba(0,102,255,0.05)'
            }} data-id="element-171">
                <ShieldCheckIcon className="w-8 h-8 md:w-11 md:h-11 text-brand-cyan drop-shadow-[0_0_8px_rgba(0,102,255,0.5)]" data-id="element-172" />
              </div>
            </motion.div>

            {/* Badge */}
            <motion.div initial={{
            opacity: 0,
            y: 8
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="inline-flex items-center gap-2.5 px-5 py-2 rounded-full mb-6 md:mb-8" style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0.03) 100%)',
            border: '1px solid rgba(255,255,255,0.12)',
            boxShadow: '0 2px 12px rgba(0,0,0,0.2)'
          }} data-id="element-173">
              <AwardIcon className="w-4 h-4 text-yellow-400 drop-shadow-[0_0_4px_rgba(250,204,21,0.4)]" data-id="element-174" />
              <span className="text-xs font-bold tracking-[0.2em] uppercase text-gray-300" data-id="element-175">
                Official & Exclusive
              </span>
            </motion.div>

            {/* Heading */}
            <motion.h2 initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.35
          }} className="text-2xl md:text-6xl font-heading font-black mb-4 md:mb-6 leading-tight" data-id="element-176">
              100% U.S.{' '}
              <span className="text-gradient" style={{
              filter: 'drop-shadow(0 0 20px rgba(0,102,255,0.3))'
            }} data-id="element-177">
                Patented
              </span>
              <br data-id="element-178" />
              Technology
            </motion.h2>

            {/* Description */}
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.45
          }} className="text-gray-400 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-179">
              Our proprietary NFC-integrated smart fabric isn't just an idea —
              it's a fully protected innovation. Accept no imitations.
              Experience the only authentic, legally recognized smart t-shirt on
              the market.
            </motion.p>
          </div>
        </motion.div>
      </div>
    </section>;
}